export default __webpack_public_path__ + "static/media/sos_logo.db514ef5.png";